/**
 * External dependencies
 */
import React, { useState } from 'react';
import { connect } from 'react-redux';

/**
 * Internal dependencies
 */
import Button from 'components/button';
import Notice from 'components/notice';

const MultiStoreNotice = ({ ...props }) => {
    const [requesting, setRequesting] = useState(null);


    return (
        <Notice
            text='For Multi-Store customers please contact accounts@towersystems.com.au to change you plan.'
            subText=''
            showDismiss={false}
        >
        </Notice>
    );
};

export default MultiStoreNotice;